import styled from "styled-components";
import materialUI from "material-UI";

export const Content = styled.div`
  width: 392px;
  min-height: 337px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const DateFilterContainer = styled.div`
  width: 100%;
`;

export const DateFilterTitle = styled.p`
  margin: 0 0 16px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #000000;
`;

export const RadioGroup = styled(materialUI.RadioGroup)`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 18px;
`;

export const FormControlLabel = styled(materialUI.FormControlLabel)`
  margin-left: -8px;
  margin-right: 0;

  .MuiTypography-body1 {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #333333;
  }
`;

export const Radio = styled(materialUI.Radio)``;

export const ButtonClear = styled.button`
  background-color: transparent;
  color: #2d5bff;
  border: none;
  cursor: pointer;
  //styleName: MD/Medium;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
`;

export const ButtonFilter = styled.button`
  background-color: transparent;
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  border-radius: 8px;
  border: none;
  cursor: pointer;
  height: 40px;
  width: 100%;
  //styleName: SM/Medium;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.01em;
  color: #ffffff;
  :disabled {
    opacity: 50%;
    cursor: not-allowed;
  }
`;

export const TextFilter = styled.p`
  //styleName: XXL/Regular;
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 24.2px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #000000;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;
